import { jsx as _jsx } from "react/jsx-runtime";
import Icon from '@/components/atoms/Icon';
import { twMerge } from 'tailwind-merge';
import Button from '../Button';
const CarouselButton = ({ className, disabled, icon, label, variant = 'solid', ...otherProps }) => {
    return (_jsx(Button, { disabled: disabled, variant: variant, children: (props) => (_jsx("button", { ...props, ...otherProps, className: twMerge(props.className, '!w-auto !p-0.75', className), "aria-label": label, children: _jsx(Icon, { className: "h-1.5 w-1.5", variant: icon }) })) }));
};
export default CarouselButton;
